var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row mt-2 row-container" }, [
    _c(
      "div",
      { staticClass: "col-2 col-sm col-12 border-right status" },
      [
        _c("balloon", {
          staticClass:
            "mt-2 font-weight-normal font-16 d-flex justify-content-center align-items-center w-80 ml-3",
          attrs: {
            bg: "bg-secondary-19",
            color: "color-secondary-20 font-weight-bold",
            text: "Error",
            "with-border": false
          }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "col-3 col-sm col-12 pl-3 pl-md-4 pl-sm-4 mt-4 mt-md-0 mt-sm-4"
      },
      [
        _c("div", { staticClass: "color-secondary-6 font-14" }, [
          _vm._v("Estudiante:")
        ]),
        _c("span", { staticClass: "color-black font-16 font-weight-bold" }, [
          _vm._v(
            " " +
              _vm._s(_vm.value.studentSieId) +
              " - " +
              _vm._s(_vm._f("capitalize")(_vm.value.fullName)) +
              " "
          )
        ])
      ]
    ),
    _c("div", { staticClass: "col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4" }, [
      _c("div", { staticClass: "color-secondary-6 font-14" }, [
        _vm._v("Servicio:")
      ]),
      _c("span", { staticClass: "color-black font-16 font-weight-normal" }, [
        _vm._v(" " + _vm._s(_vm.value.serviceDescription) + " ")
      ])
    ]),
    _c("div", { staticClass: "col-2 col-sm col-6 mt-4 mt-md-0 mt-sm-4" }, [
      _c("div", { staticClass: "color-secondary-6 font-14" }, [
        _vm._v("Periodo:")
      ]),
      _c("span", { staticClass: "color-black font-16 font-weight-normal" }, [
        _vm._v(" " + _vm._s(_vm.value.period) + " ")
      ])
    ]),
    _c("div", { staticClass: "col-3 col-sm col-12 mt-4 mt-md-0 mt-sm-4" }, [
      _c("div", { staticClass: "color-secondary-6 font-14" }, [
        _vm._v("Razón:")
      ]),
      _c(
        "span",
        { staticClass: "color-black font-16 font-weight-normal" },
        [
          _c("custom-error", {
            attrs: {
              message: _vm.value.reason,
              variant: "no-border ml-n1 reason"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "col d-flex align-items-center justify-content-end pr-5" },
      [
        _c(
          "action-button",
          {
            attrs: { i: "fas fa-comment", variant: "outline-success" },
            on: { click: _vm.setComment }
          },
          [_vm._v(" Comentario ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }